import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';

Vue.use(Vuex)

/*
 *   getters/actions/mutations
 */
const state = {

}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {

}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules,
  strict: process.env.NODE_ENV !== 'production'
})




// WEBPACK FOOTER //
// ./src/store/index.js